import { DayType } from "./DayType";

export class DayTypeFunctions {
    public static WeekDays(): DayType[] {
        return [
            DayType.Monday,
            DayType.Tuesday,
            DayType.Wednesday,
            DayType.Thursday,
            DayType.Friday,
            DayType.Saturday,
            DayType.Sunday,
        ];
    }

    public static HolidayDays(): DayType[] {
        return [DayType.DayBeforeHoliday, DayType.DayOnHoliday, DayType.DayAfterHoliday];
    }

    public static WeekDaysMap(): { [type: number]: string } {
        return DayTypeFunctions.DaysMap(DayTypeFunctions.WeekDays());
    }

    public static HolidayDaysMap(): { [type: number]: string } {
        return DayTypeFunctions.DaysMap(DayTypeFunctions.HolidayDays());
    }

    private static DaysMap(days: DayType[]) {
        return days.reduce((acc: any, val) => {
            acc[val] = DayType[val];
            return acc;
        }, {});
    }
}
